

import React from "react"

/**
 * Open svg icon with defined properties as per UI
 * @returns OpenSvg JSX
 */

export const OpenSvg = (props: any) => {
    const {className} = props
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <circle cx="6.02301" cy="14.9996" r="1.38238" stroke="#717171" />
            <circle cx="17.8824" cy="14.8824" r="1.38238" stroke="#717171" />
            <path d="M3 10.7324L4.30515 7.26562H7.17649M3 10.7324V14.9991H4.62244M3 10.7324H7.17649V7.26562M9.26473 14.9991V7.26562H7.17649M9.26473 14.9991L7.5 14.9986M9.26473 14.9991L15 14.9986L16.5673 14.9991M9.26473 14.9991V11.1324H21V14.9988L19.5224 14.999" stroke="#717171" />
        </svg>
    )
}
